/*
 * Weihnachten (sections/mhsys-wn-held.liquid): Countdown bis Heiligabend (Tage) und die Lage des Lieferversprechens,
 * beides erst ab dem 1. Dezember (data-countdown-ab), vorher der Hinweis auf den Fahrplan.
 * Liquid schreibt die Lage beim Rendern; die Seite kann aber aus dem Cache kommen, deshalb rechnet der Browser
 * neu. Die Termine (data-sicher, data-letzt, data-heiligabend: "JJJJ-MM-TT HH:MM") gelten in deutscher Zeit -
 * umgerechnet über den Versatz von Europe/Berlin zu genau diesem Zeitpunkt (Winterzeit, also +1 Stunde).
 */
(function () {
  var held = document.querySelector('[data-mhsys-wn]');
  if (!held) return;

  function zeitpunkt(text) {
    var m = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{1,2}):(\d{2})$/.exec((text || '').trim());
    if (!m) return null;
    var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var versatz = 60;
    /* Berliner Versatz aus window.mhsysBerlin (layout/theme.liquid) - Intl kostet beim ersten Aufruf ~70 ms am Handy */
    try { versatz = window.mhsysBerlin(new Date(utc)).versatz; } catch (e) {}
    return utc - versatz * 60000;
  }

  var sicher = zeitpunkt(held.dataset.sicher);
  var letzt = zeitpunkt(held.dataset.letzt);
  var heiligabend = zeitpunkt(held.dataset.heiligabend);
  var countdownAb = zeitpunkt(held.dataset.countdownAb);
  var countdown = held.querySelector('[data-mhsys-wn-countdown]');
  var versprechen = held.querySelector('[data-mhsys-wn-versprechen]');
  var vorher = held.querySelector('[data-mhsys-wn-vorher]');
  var tage = held.querySelector('[data-mhsys-wn-tage]');

  // Roadmap 3.94: eine Zeile - vor dem 1. Dezember nur der Fahrplan, danach Countdown (Tage) und Lieferversprechen
  function lageSetzen(jetzt, advent) {
    var lage = 'sicher';
    if (sicher && jetzt >= sicher) lage = 'letzt';
    if (letzt && jetzt >= letzt) lage = 'gutschein';
    if (heiligabend && jetzt >= heiligabend) lage = 'vorbei';
    if (!versprechen) return lage;
    versprechen.dataset.lage = lage;
    versprechen.hidden = !advent || lage === 'vorbei';
    versprechen.querySelectorAll('[data-lage-text]').forEach(function (el) {
      el.hidden = el.getAttribute('data-lage-text') !== lage;
    });
    return lage;
  }

  function takt() {
    var jetzt = Date.now();
    var rest = heiligabend ? heiligabend - jetzt : 0;
    var advent = !!heiligabend && rest > 0 && !(countdownAb && jetzt < countdownAb);
    lageSetzen(jetzt, advent);
    if (vorher) vorher.hidden = advent;
    if (!countdown) return;
    countdown.hidden = !advent;
    if (!advent || !tage) return;
    tage.textContent = Math.floor(rest / 86400000);
  }

  takt();
  setInterval(takt, 30000);

  /* Die Flocken im Einstieg bewegen sich nur, solange er zu sehen ist (ist-weg hält die CSS-Animation an): jedes
     bewegte Bild kostet mit (Messung 26.09.2026, bei Schneefall rund doppelte Last) */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      held.classList.toggle('ist-weg', !e[0].isIntersecting);
    }).observe(held);
  }
})();
